import { SmartAccountType } from "@wallet-manager/node-types/dist/src/postgres/const";
import cond from "lodash/cond";
import { FieldsFace } from "../types/FieldsFace";
import { ProfileLoginFace } from "src/reducer/profileSlice";
import { ChainFace, chainPieceFace } from "src/reducer/chainsSlice";
import { enumChainIdToType } from "src/utils/constant";
import {
  findDecimalByChainNameAndAsset,
  toDBInDecimals,
} from "src/utils/helper";

export function getParams(
  fields: FieldsFace,
  selectChainByPieces: (params: Partial<chainPieceFace>) => Partial<ChainFace>,
  profile: ProfileLoginFace,
  settlementTime: {
    wallet_settlement_date_from: string | undefined;
    wallet_settlement_date_to: string | undefined;
  },
) {
  const {
    chain_name,
    max_sweepable_address,
    acceptant_risk_level_array,
    risk_level,
    include_no_risk_level_wallet: include_no_risk_level_wallet_str,
    is_smart_account,
    is_free_bandwidth_only,
    wallet_version,
    ...rest
  } = fields;
  const { chain_id, chain_type, support_smart_account } = selectChainByPieces({
    chain_name,
  });
  const decimals = findDecimalByChainNameAndAsset(
    String(chain_type),
    String(chain_id),
    fields.asset_name,
  );
  const defaultCase = () => true;
  const theRiskLevel = cond([
    [() => profile.chain_analysis === false, () => []],
    [
      () => acceptant_risk_level_array.length > 0,
      () => acceptant_risk_level_array,
    ],
    [() => risk_level !== "acceptant", () => [risk_level]],
    [defaultCase, () => []],
  ])().map((ele: string) => Number(ele));
  const include_no_risk_level_wallet = !!Number(
    include_no_risk_level_wallet_str,
  );

  const getSmartAccountType = () => {
    if (!support_smart_account) {
      return undefined;
    }

    if (!is_smart_account) {
      return SmartAccountType.EOA;
    }

    if (enumChainIdToType.TRON === String(chain_type)) {
      return SmartAccountType.TronRentalEnergyBandwidth;
    }
    if (enumChainIdToType.ETH === String(chain_type)) {
      return SmartAccountType.Kernel;
    }
  };

  const getTronFreeBandwidthOnly = () => {
    if (enumChainIdToType.TRON !== String(chain_type) || !is_smart_account) {
      return undefined;
    }

    return is_free_bandwidth_only;
  };

  const smart_account_type = getSmartAccountType();

  const tron_free_bandwidth_only = getTronFreeBandwidthOnly();

  return {
    ...rest,
    limit: max_sweepable_address,
    threshold: toDBInDecimals(fields.threshold, decimals),
    risk_level: theRiskLevel,
    include_no_risk_level_wallet,
    decimals,
    chain_id,
    chain_type,
    smart_account_type,
    tron_free_bandwidth_only,
    wallet_version: wallet_version || undefined,
    ...settlementTime,
  };
}
